import {
  Container,
  Grid,
  Card,
  Typography,
  IconButton,
  TextField,
  Autocomplete,
  Paper,
  Button,
  Avatar,
  Box,
  Modal,
  CardContent,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import i18next, { init } from 'i18next';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getRole, getToken } from '../../utils/common';
import CircleIcon from '@mui/icons-material/Circle';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { formatEpochToDateString } from 'src/components/helper';
import DialogUpload from 'src/components/dialog/alert-detail/upload';
import CloudCircleIcon from '@mui/icons-material/CloudCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { message, notification, Space } from 'antd';
import { ArrowCircleDownOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import DialogPreview from 'src/components/dialog/alert-detail/preview';
import CardMedia from '@mui/material/CardMedia';
const _ = require('lodash');
import { pdfjs } from 'react-pdf';
import Nopreview from '../../../src/style/no-preview.png';
import ImageNull from '../../../src/style/imagenull.png';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { getAclMenu } from '../../utils/common';

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

export default function DetailAlert() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const [acl, setAcl] = useState(getAclMenu('action'));
  const [datadecoded, setDatadecoded] = React.useState({});
  const [data, setData] = React.useState('');
  const [orderlist, setOrderList] = React.useState([]);
  const [date, setDate] = React.useState(null);
  const [action, setAction] = React.useState([]);
  const [newstatus, setNewstatus] = React.useState('');
  const [files, setFiles] = useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [selectedIndexafter, setSelectedIndexafter] = React.useState(0);
  const [history, setHistory] = React.useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imagePreviews2, setImagePreviews2] = useState([]);
  const [loading, setloading] = useState({ loading1: false, loading2: false });
  const [datachenges, setDatachanges] = useState([]);
  const [newstatusprocess, setNewstatusprocess] = useState({
    status: '',
    closed_status: '',
  });
  const [image, setImage] = React.useState({
    nameFileAfter: [],
    nameFileBefore: [],
    byteImageAfter: [],
    ByteImageBefore: [],
  });
  const [dialogUpload, setDialogUpload] = React.useState({
    open: false,
    handleClose: () => {
      setDialogUpload((prevState) => ({ ...prevState, open: !prevState.open }));
    },
  });
  const [dialogUploadPreview, setDialogUploadPreview] = React.useState({
    open: false,
    base64String: '',
    type: '',
    handleClose: () => {
      setDialogUploadPreview((prevState) => ({ ...prevState, open: !prevState.open }));
    },
    path: '',
    filename: '',
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchInfo = (url, decodedId) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.code === 401) {
          setData('');
        } else {
          setData({
            ...d,
            status: JSON.parse(decodedId)?.status,
          });
          fetchInfo33(JSON.parse(decodedId)?.recordId);

          if (JSON.parse(decodedId).status == 'open') {
            fetchInfo5(window.REACT_APP_API_PURE + `action/list?assign=${JSON.parse(decodedId)?.dataSet}`, setAction);
          } else {
            fetchInfo5(window.REACT_APP_API_PURE + `alert/action?id=` + JSON.parse(decodedId)?.id, setAction);
          }

          setDate(d?.[d.length - 1]?.histories[d?.[d.length - 1]?.histories.length - 1].epoch);
          setOrderList(d?.[d.length - 1].histories);

          let selectedIndexafter = d?.[d.length - 1].histories.length;
          let hashAfter = [];
          let hashBefore = [];
          let indexbefore = 0;

          if (selectedIndexafter > 1) {
            ///scan to find hash after
            hashAfter.push(d?.[d.length - 1].histories[selectedIndexafter - 1]);

            //scan to find hash before
            indexbefore = d?.[d.length - 1].histories?.findIndex((option) => option.epoch === hashAfter[0].epoch);
            hashBefore = d?.[d.length - 1].histories
              .filter((item, index) => index <= indexbefore)
              .reduce((acc, item) => {
                if (item.authorized) {
                  acc.unshift(item);
                }
                return acc;
              }, []);
          } else {
            hashBefore.push(d?.[d.length - 1].histories[0]);
            hashAfter.push(d?.[d.length - 1].histories[1]);
          }
          selectedIndexafter =
            d?.[d.length - 1].histories?.findIndex((option) => option?.epoch === hashAfter[0]?.epoch) - 1;

          fetchInfo4(
            window.REACT_APP_API_PURE + `record/compare/${JSON.parse(decodedId)?.recordId}/${hashAfter[0]?.id}`,
            setData,
            { isChange: true },
            0,
            selectedIndexafter < 1 ? 0 : selectedIndexafter
          );
          // } else {
          //   fetchImage(d[d.length - 1]?.history?.before, d[d.length - 1]?.history?.after);
          // }
        }
      });
  };

  const findPath = (obj, target) => {
    for (const key in obj) {
      if (key === target) {
        return [key];
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        const path = findPath(obj[key], target);
        if (path.length > 0) {
          return [key, ...path];
        }
      }
    }
    return [];
  };

  function setNullRecursive(obj) {
    // Base case: if obj is not an object, return null
    if (typeof obj !== 'object' || obj === null) {
      return null;
    }

    // If obj is an array, set each element to null
    if (Array.isArray(obj)) {
      return obj.map(setNullRecursive);
    }

    // If obj is an object, recursively set each property to null
    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = setNullRecursive(obj[key]);
      }
    }

    return result;
  }

  const replaceValuesWithEmpty = (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        replaceValuesWithEmpty(obj[key]);
      } else {
        obj[key] = '';
      }
    }
  };

  function transformObjectStructure(target, template) {
    for (const key in template) {
      if (template.hasOwnProperty(key)) {
        if (typeof template[key] === 'object' && template[key] !== null) {
          if (!target.hasOwnProperty(key) || target[key] === null) {
            target[key] = {};
          }
          transformObjectStructure(target[key], template[key]);
        } else {
          if (!target.hasOwnProperty(key) || target[key] === null) {
            target[key] = '';
          }
        }
      }
    }
    return target;
  }
  function reorderObject(obj1, obj2) {
    let reorderedObj = {};
    // Recursively check for missing properties in obj2 and set to null if absent
    function recursiveReorder(o1, o2) {
      let tempObj = {};
      if (typeof o1 !== 'string' && isNaN(o1)) {
        Object.keys(o1).forEach((key) => {
          if (o2?.hasOwnProperty(key)) {
            if (typeof o1[key] === 'object' && o1[key] !== null) {
              tempObj[key] = recursiveReorder(o1[key], o2[key]);
            } else {
              tempObj[key] = o2[key]; // Direct copy if not an object
            }
          } else {
            tempObj[key] = null;
          }
        });
      } else {
        tempObj = o2;
      }

      return tempObj;
    }

    // Start by calling recursive reorder for each key in obj1
    Object.keys(obj1).forEach((key) => {
      if (obj2.hasOwnProperty(key)) {
        reorderedObj[key] = recursiveReorder(obj1[key], obj2[key]);
      } else {
        // If the whole key is missing in obj2, add it with null
        reorderedObj[key] = null;
      }
    });

    return reorderedObj;
  }
  const fetchInfo4 = useCallback(
    async (url, setdata, { isChange = true }, selectedIndex, selectedIndexafter) => {
      try {
        fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            if (isChange) setImagePreviews([]);
            setImagePreviews2([]);

            let databeforeupdate = d?.before || [];

            let dataafterupdate = d?.after || [];
            let transformeddataafter = {};

            if (dataafterupdate.length === 0) {
              transformeddataafter = setNullRecursive(databeforeupdate);
            } else {
              transformeddataafter = transformChangesRemove(
                [...(d.updates || []), ...(d.invalids || [])],
                dataafterupdate
              );
              transformObjectStructure(databeforeupdate, transformeddataafter);
            }
            transformeddataafter = reorderObject(databeforeupdate, transformeddataafter);

            if (isChange) {
              setSelectedIndex(selectedIndex);
              setSelectedIndexafter(selectedIndexafter);
              setdata([
                {
                  history: {
                    after: transformeddataafter,
                    before: databeforeupdate,
                    invalids: d?.invalids,
                    updates: d?.updates,
                  },
                  status: datadecoded.status,
                },
              ]);

              fetchImage(databeforeupdate, transformeddataafter);
            } else {
              setdata([
                {
                  history: {
                    after: d?.after,
                    before: data[0]?.history?.before,
                    invalids: d?.invalids,
                    updates: d?.updates,
                  },
                  status: datadecoded.status,
                },
              ]);
              fetchImage([], d?.after);
            }
          });
      } catch (error) {}
    },
    [data, setData]
  );

  const fetchInfo5 = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata(d);
      });
  };

  const fetchInfo7 = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata(d?.data || []);
      });
  };

  const fetchInfo6 = (status, keterangan) => {
    var recreatefiles = [];

    files?.map((item) => {
      recreatefiles.push({
        name: item.name || item.nama_file,
        size: item.size || 0,
        type: item.type || '',
        contents: item.contents || item.file,
      });
    });
    return fetch(window.REACT_APP_API_PURE + 'alert/edit', {
      method: 'POST',
      body: JSON.stringify({
        id: datadecoded.id,
        status: status,
        action: action?.data,
        note: keterangan,
        files: recreatefiles,
      }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('SuccessAlert.1'),
            placement: 'top',
            duration: 0,
          });
        } else {
          notification.error({
            message: 'Error',
            description: t('SuccessAlert.2'),
            placement: 'top',
            duration: 0,
          });
        }
        navigate('/dashboard/alert');
      });
  };

  const fetchapprovechecker = (status, keterangan) => {
    var recreatefiles = [];

    files?.map((item) => {
      recreatefiles.push({
        name: item.name || item.nama_file,
        size: item.size || 0,
        type: item.type || '',
        contents: item.contents || item.file,
      });
    });
    return fetch(window.REACT_APP_API_PURE + 'alert/edit/approvereject', {
      method: 'POST',
      body: JSON.stringify({
        id: datadecoded.id,
        status: status,
        action: action?.data,
        note: keterangan,
        files: recreatefiles,
      }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('SuccessAlert.1'),
            placement: 'top',
            duration: 0,
          });
        } else {
          notification.error({
            message: 'Error',
            description: t('SuccessAlert.2'),
            placement: 'top',
            duration: 0,
          });
        }
        navigate('/dashboard/alert');
      });
  };

  const fetchImage = async (before, after) => {
    setloading((prevState) => ({ ...prevState, loading1: true, loading2: true }));
    for (const key in before) {
      if (before.hasOwnProperty(key)) {
        const file = before[key];
        const fileHash = file?.fileHash;
        const filename = key;
        const path = file?.metaData?.storageMetaData?.path;
        if (path != undefined) {
          const handlePreview = async (fileUrl) => {
            try {
              const response = await fetch(fileUrl, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              });

              if (!response.ok) {
                setImagePreviews((prevPreviews) => [
                  ...prevPreviews,
                  { url: '', type: 'png', path: path, filename: filename, fileHash: fileHash },
                ]);
                console.error(`Error downloading file: ${response.statusText}`);
                return;
              }

              const contentType = response.headers.get('Content-Type');
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              const parts = filename.split('.');

              // Get the last part (the file extension)
              const fileExtension = parts[parts.length - 1];
              // Add the URL to the previews array

              setImagePreviews((prevPreviews) => [
                ...prevPreviews,
                { url, type: 'png', path: path, filename: filename, fileHash: fileHash },
              ]);
              setloading((prevState) => ({ ...prevState, loading1: false }));

              // Clean up
              // URL.revokeObjectURL(url);
            } catch (error) {
              setImagePreviews((prevPreviews) => [
                ...prevPreviews,
                { url: '', type: 'png', path: path, filename: filename, fileHash: fileHash },
              ]);

              console.error('Error fetching file:', error);
              setloading((prevState) => ({ ...prevState, loading1: false }));
            }
          };
          handlePreview(
            window.REACT_APP_API_PURE +
              `record/download/file/${encodeURIComponent(path.replace(/\//g, '%2F'))}/thumbnail`,
            filename
          );
        } else {
          setImagePreviews((prevPreviews) => [
            ...prevPreviews,
            { url: path, type: 'png', path: path, filename: filename, fileHash: fileHash },
          ]);
        }
      }
    }

    for (const key in after) {
      if (after.hasOwnProperty(key)) {
        const file = after[key];
        const fileHash = file?.fileHash;
        const filename = key;
        const path = file?.metaData?.storageMetaData?.path;
        if (path != undefined) {
          const handlePreview = async (fileUrl) => {
            try {
              const response = await fetch(fileUrl, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              });

              if (!response.ok) {
                setImagePreviews2((prevPreviews) => [
                  ...prevPreviews,
                  { url: '', type: 'png', path: path, filename: filename, fileHash: fileHash },
                ]);
                console.error(`Error downloading file: ${response.statusText}`);
                return;
              }

              const contentType = response.headers.get('Content-Type');
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              const parts = filename.split('.');

              // Get the last part (the file extension)
              const fileExtension = parts[parts.length - 1];
              // Add the URL to the previews array

              setImagePreviews2((prevPreviews) => [
                ...prevPreviews,
                { url, type: fileExtension, path: path, filename: filename, fileHash: fileHash },
              ]);
              setloading((prevState) => ({ ...prevState, loading2: false }));
              // Clean up
              // URL.revokeObjectURL(url);
            } catch (error) {
              setImagePreviews2((prevPreviews) => [
                ...prevPreviews,
                { url: '', type: 'png', path: path, filename: filename, fileHash: fileHash },
              ]);
              console.error('Error fetching file:', error);
              setloading((prevState) => ({ ...prevState, loading2: false }));
            }
          };
          handlePreview(
            window.REACT_APP_API_PURE +
              `record/download/file/${encodeURIComponent(path?.replace(/\//g, '%2F'))}/thumbnail`,
            filename
          );

          // try {
          //   const fileUrl = window.REACT_APP_API_PURE +`record/download/file/${path}`;
          //   const response = await fetch(fileUrl);
          //   const blob = await response.text();

          //   //  promises new Promise((resolve) => {
          //   //     const reader = new FileReader();
          //   //     reader.onloadend = () => {
          //   //       resolve(reader.result);
          //   //     };
          //   //     reader.readAsDataURL(blob);
          //   //   });
          //   //   const resolvedPreviews = await Promise.all(promises);

          // } catch (error) {
          //   console.error('Error fetching or reading files:', error);
          // }
        } else {
          setImagePreviews2((prevPreviews) => [
            ...prevPreviews,
            { url: path, type: 'png', path: path, filename: filename, fileHash: fileHash },
          ]);
        }
      }
    }
  };

  const fetchInfo33 = useCallback(
    async (id) => {
      try {
        return fetch(window.REACT_APP_API_PURE + 'record/changes/' + id, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            if (d.code === 401) {
              // setData([]);
              // settotal(0);
            } else {
              var total = d?.unAuthorizedChanges;

              setDatachanges((currenData) => [
                ...currenData,
                {
                  id: id,
                  total: total,
                  authorizedChanges: d?.authorizedChanges,
                  unAuthorizedChanges: d?.unAuthorizedChanges,
                },
              ]);
              // console.log
            }
          });
      } catch (error) {}
    },
    [datachenges, setDatachanges]
  );

  useEffect(() => {
    // setFiles
    const decodedId = atob(id);
    setDatadecoded(JSON.parse(decodedId));
    fetchInfo7(window.REACT_APP_API_PURE + `file/list?alert_id=` + JSON.parse(decodedId)?.id, setFiles);
    fetchInfo5(window.REACT_APP_API_PURE + `alert/history?id=` + JSON.parse(decodedId)?.id, setHistory);
    fetchInfo(window.REACT_APP_API_PURE + 'alert/' + JSON.parse(decodedId)?.id + '/data', decodedId);
  }, []);

  function CardHeaderHistory() {
    const { t } = useTranslation();

    return (
      <Card style={{ padding: 20 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={12} container direction={'row'} spacing={2}>
            <Grid item alignSelf={'center'}>
              {' '}
              <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
            </Grid>
            <Grid item>
              <Typography variant="h5">{t('Historical.1')}</Typography>
            </Grid>
          </Grid>
          {ComponentAuth({ color: '#EE5020', title: t('UnauthorizedChanges.1') })}
          {ComponentAuth({ color: '#1EB3D9', title: t('AuthorizedChanges.1') })}
          <Grid item container direction={'row'} xs={12}>
            <div style={{ overflow: 'auto', marginTop: 10, marginBottom: 10, paddingLeft: 20 }}>
              <Grid item xs={12} container direction={'row'} style={{ overflowX: 'auto', minWidth: 'max-content' }}>
                {orderlist?.map((data, row) => {
                  return (
                    <div item>
                      {MyComponent({
                        valid: data.authorized,
                        invalid: data.unauthorized,
                        timeEpoch: data.epoch,
                        isEndList: orderlist.length == row + 1,
                      })}
                    </div>
                  );
                  // }
                  // }
                })}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Card>
    );
  }

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    // Read each selected file and convert it to base64
    const filePromises = Array.from(selectedFiles).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(',')[1];
          resolve({ name: file.name, size: file.size, contents: base64String, type: file.type });
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });

    // Set the state with an array of objects containing name and contents
    Promise.all(filePromises)
      .then((fileObjects) => setFiles((prevState) => [...prevState, ...fileObjects]))
      .catch((error) => console.error('Error reading files:', error));
  };

  return (
    <Container>
      <DialogUpload
        open={dialogUpload.open}
        handleClose={dialogUpload.handleClose}
        handleFileChange={handleFileChange}
        files={files}
      />
      {dialogUploadPreview.open && (
        <DialogPreview
          open={dialogUploadPreview.open}
          handleClose={dialogUploadPreview.handleClose}
          handleFileChange={handleFileChange}
          data={dialogUploadPreview.base64String}
          files={files}
          path={dialogUploadPreview.path}
          type={dialogUploadPreview.type}
          filename={dialogUploadPreview.filename}
        />
      )}
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={12}>
          {CardBack(navigate)}
        </Grid>
        <Grid item xs={12}>
          {CardHeader(datadecoded, datachenges, orderlist)}
        </Grid>
        <Grid item xs={12}>
          {CardHeaderHistory()}
        </Grid>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item xs={6}>
            <Card style={{ padding: 20 }}>
              <Grid container direction={'row'} justifyContent={'space-between'}>
                <Grid item container direction={'row'} spacing={1}>
                  <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
                    <Grid item>
                      <Typography variant="h5">
                        {orderlist?.length == 1 ? t('HasnoAuthUpdate.1') : t('BeforeUpdate.1')}
                      </Typography>
                    </Grid>
                  </Grid>
                  {orderlist?.length == 1 ? (
                    ''
                  ) : (
                    <Grid item xs={12} container direction={'row'} spacing={2}>
                      <Grid item>
                        {formatEpochToDateString(orderlist[selectedIndex]?.epoch) == 'Invalid Date'
                          ? ''
                          : formatEpochToDateString(orderlist[selectedIndex]?.epoch)}
                      </Grid>
                      <Grid item>
                        <Typography>To</Typography>
                      </Grid>
                      <Grid item>
                        {' '}
                        {formatEpochToDateString(orderlist[selectedIndexafter]?.epoch) == 'Invalid Date'
                          ? ''
                          : formatEpochToDateString(orderlist[selectedIndexafter]?.epoch)}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Paper
              style={{
                padding: 20,
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              }}
            >
              <Grid container direction={'row'} justifyContent={'space-between'}>
                <Grid item container direction={'row'} xs spacing={2}>
                  <Grid item>
                    {' '}
                    <Typography variant="h5">{t('DataUpdate.1')}</Typography>
                  </Grid>{' '}
                  <Grid item xs={7}>
                    {' '}
                    {/* {DatePickerGlobal({ value: date, dateList: orderlist, onSelectDate: handleDateChange })} */}
                    <Autocomplete
                      disableClearable
                      fullWidth
                      size="small"
                      key={id}
                      disablePortal
                      // value={(orderlist || []).find((e) => e['epoch'] === date)}
                      id={id}
                      onChange={(event, newValue) => {
                        let selectedIndex = orderlist?.findIndex((option) => option.epoch === newValue.epoch);
                        let selectedIndexafter = selectedIndex;
                        let hashBefore = [];
                        let hashAfter = [];
                        let indexbefore = 0;

                        if (selectedIndex > 1) {
                          ///scan to find hash after
                          hashAfter.push(orderlist[selectedIndex]);

                          //scan to find hash before
                          indexbefore = orderlist?.findIndex((option) => option.epoch === hashAfter[0].epoch);
                          hashBefore = orderlist
                            .filter((item, index) => index <= indexbefore)
                            .reduce((acc, item) => {
                              if (item.authorized) {
                                acc.unshift(item);
                              }
                              return acc;
                            }, []);
                          selectedIndexafter =
                            orderlist?.findIndex((option) => option.epoch === hashAfter[0].epoch) - 1;
                        } else {
                          hashBefore.push(orderlist[0]);
                          hashAfter.push(orderlist[1]);
                          if (orderlist[1].unauthorized) {
                            selectedIndexafter = 0;
                          } else {
                            selectedIndexafter = 1;
                          }
                        }

                        setDate(newValue.epoch);
                        fetchInfo4(
                          window.REACT_APP_API_PURE + `record/compare/${datadecoded.recordId}/${hashAfter[0]?.id}`,
                          setData,
                          { isChange: true },
                          0,
                          selectedIndexafter < 1 ? 0 : selectedIndexafter
                        );
                      }}
                      options={orderlist.slice(1)}
                      getOptionLabel={(dropdown) => formatEpochToDateString(dropdown.timestamp) || ''}
                      getOptionSelected={(option, selectedValue) => option['epoch'] === selectedValue['epoch']}
                      renderInput={(params) => (
                        <TextField
                          placeholder={formatEpochToDateString(date)}
                          key={id}
                          {...params}
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: '12px' }, // Adjust the font size as needed
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item xs={6}>
            {GererateDataBeforeAfter({
              title: t('RecordfromBlockchain.1'),
              data: data[0]?.history.height == 1 ? {} : data[0]?.history?.before,
              invalidpath: data[0]?.history?.invalids,
              type: 'add',
              previews: imagePreviews,
              fileName: image.nameFileBefore,
              setDialogUploadPreview: setDialogUploadPreview,
              before: '',
              after: data[0]?.history?.after,
              loading: loading.loading1,
              updatepath: data[0]?.history?.updates,
              height: data[0]?.history.height,
              closedStatus: datadecoded.closedStatus,
              authorized: data[0]?.history?.authorized,
              unauthorized: data[0]?.history?.unauthorized,
            })}
          </Grid>
          <Grid item xs={6}>
            {GererateDataBeforeAfter({
              title: t('DataVerifResult.1'),
              data: data[0]?.history?.after,
              invalidpath: data[0]?.history?.invalids,
              type: 'remove',
              previews: imagePreviews2,
              fileName: image.nameFileAfter,
              setDialogUploadPreview: setDialogUploadPreview,
              before: data[0]?.history?.before,
              after: '',
              loading: loading.loading2,
              updatepath: data[0]?.history?.updates,
              height: data[0]?.history.height,
              closedStatus: datadecoded.closedStatus,
            })}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {ActionSection({
            action: action?.data,
            dataset: datadecoded?.dataSet,
            setAction,
            status: datadecoded?.status,
            fetchInfo6,
            fetchapprovechecker,
            setNewstatus,
            dialogUpload,
            files,
            setFiles,
            newstatusprocess,
            setNewstatusprocess,
            closedStatus: datadecoded.closedStatus,
            acl: acl,
          })}
        </Grid>
        <Grid item xs={12}>
          {HisrotySection({ history: history?.data || [] })}
        </Grid>
      </Grid>
    </Container>
  );
}

function GererateDataBeforeAfter({
  title: title,
  data: data,
  invalidpath: invalidpath,
  type: type,
  previews: previews,
  fileName: fileName,
  setDialogUploadPreview: setDialogUploadPreview,
  before: before,
  after: after,
  loading: loading,
  updatepath: updatepath,
  height: height,
  closedStatus: closedStatus,
  authorized: authorized,
  unauthorized: unauthorized,
}) {
  return (
    <Card style={{ padding: 20 }}>
      <Grid container direction={'row'}>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item alignSelf={'center'}>
            {' '}
            <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">{title}</Typography>
          </Grid>
          {GenerateObject({
            data: data,
            invalidpath: invalidpath,
            initialinvalidpath: '/',
            type: type,
            before: before,
            after: after,
            updatepath: updatepath,
            height: height,
            closedStatus: closedStatus,
            authorized: authorized,
            unauthorized: unauthorized,
            // fetchImage: fetchImage,
          })}
        </Grid>
        <Grid item container direction={'row'} xs={12} style={{ padding: 20 }}>
          {previews.map((preview, index) =>
            isValidFileName(preview.filename, preview?.fileHash) ? (
              ''
            ) : (
              <Grid item xs={6}>
                {type == 'add' ? (
                  <div>&nbsp;</div>
                ) : isValidFileName(preview.filename, preview?.fileHash) ? (
                  ''
                ) : (
                  <Typography
                    style={{
                      color:
                        type == 'add'
                          ? ''
                          : checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
                            invalidpath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                            invalidpath?.some((item) => item.path == '/' + preview.filename)
                          ? 'red'
                          : updatepath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                            updatepath?.some((item) => item.path == '/' + preview.filename) ||
                            checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath)
                          ? 'green'
                          : '',
                    }}
                  >
                    {checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
                    invalidpath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                    invalidpath?.some((item) => item.path == '/' + preview.filename) ? (
                      '(Unauthorized change detected)'
                    ) : updatepath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                      updatepath?.some((item) => item.path == '/' + preview.filename) ||
                      checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath) ? (
                      '(Authorized change detected)'
                    ) : (
                      <div>&nbsp;</div>
                    )}
                  </Typography>
                )}
                {
                  <div key={index}>
                    <Card
                      raised
                      sx={{
                        backgroundColor:
                          type == 'add'
                            ? ''
                            : checkPathContainsSubPath(invalidpath, 'fileHash', '', updatepath) ||
                              (height == 1 && unauthorized) ||
                              invalidpath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                              invalidpath?.some((item) => item.path == '/' + preview.filename)
                            ? 'var(--red-500, #ff001a52)'
                            : (height == 1 && authorized) ||
                              updatepath?.some((item) => item.path.includes('/' + preview.filename + '/fileHash')) ||
                              updatepath?.some((item) => item.path == '/' + preview.filename) ||
                              checkPathContainsSubPath(updatepath, 'fileHash', '', invalidpath)
                            ? 'var(--yellow-100, #dcffd7)'
                            : '',
                        maxWidth: 150,
                        margin: '0 auto',
                        padding: '0.1em',
                        position: 'relative',
                        transition: 'box-shadow 0.3s ease',
                        '&:hover': {
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={preview.url || (preview.path == '' || preview.path == null ? ImageNull : Nopreview)}
                        alt={`Preview ${index}`}
                        // title={'titleasdasdsada'}
                        sx={{
                          padding: '1em 1em 0 1em',
                          objectFit: 'contain',
                          backgroundColor: preview.path != '' ? '' : type != 'add' ? '' : 'gray',
                          color: 'red',
                        }}
                        onClick={() => {
                          if (preview.path != '' && preview.fileHash != null) {
                            setDialogUploadPreview((prevState) => ({
                              ...prevState,
                              open: !prevState.open,
                              base64String: preview.url,
                              type: preview.type,
                              path: preview.path,
                              filename: preview.filename,
                            }));
                          } else {
                            // alert('No Preview Available');
                          }
                        }}
                      />
                      <CardContent
                        style={{
                          textAlign: 'center',
                          backgroundColor: preview.path != '' ? '' : type != 'add' ? '' : 'gray',
                        }}
                      >
                        <Typography variant="caption">
                          {' '}
                          {preview.path != '' && preview.fileHash ? preview.filename : ''}
                        </Typography>
                      </CardContent>

                      {preview.filename.includes('pdf') && (
                        <PictureAsPdfIcon
                          fontSize="large"
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            color: 'red', // Set the background color as needed
                          }}
                        />
                      )}
                      {preview.filename.includes('mp3') && (
                        <LibraryMusicIcon
                          fontSize="large"
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            color: '#1EB3D9', // Set the background color as needed
                          }}
                        />
                      )}
                    </Card>
                  </div>
                }
              </Grid>
            )
          )}
        </Grid>
      </Grid>
    </Card>
  );
}

const isValidFileName = (fileName, filehash) => {
  if (filehash != null || filehash != undefined) {
    return false;
  }
  // Define the regex pattern to match invalid file extensions
  const invalidExtensions = /\.(pdf|jpg|png|doc|docx|xls|xlsx)$/i;

  // Test the fileName against the pattern
  return !invalidExtensions.test(fileName);
};

function determineType(data) {
  if (Array.isArray(data)) {
    return 'array';
  } else if (typeof data === 'object' && data !== null) {
    return 'object';
  } else {
    return 'unknown';
  }
}
function GenerateObject({
  data: data,
  invalidpath: invalidpath,
  initialinvalidpath: newinitialinvalidpath,
  type: type,
  before: before,
  after: after,
  updatepath: updatepath,
  height: height,
  closedStatus: closedStatus,
  authorized: authorized,
  unauthorized: unauthorized,
  // fetchImage: fetchImage,
}) {
  return Object.keys(data || {})?.map((key, index) => {
    const typevalue = checkValueType(data[key]);
    let initialinvalidpath = newinitialinvalidpath;
    let tittle = capitalizeFirstLetter(key);
    let value = data[key];

    let invalidobject = {};
    let validobject = {};

    // if (typevalue == 'object') {
    //   console.log(key);
    // }

    if (typevalue == 'string' || data[key] == null || typevalue != 'object') {
      try {
        // Split the string by '/'
        const splitUrl = (initialinvalidpath + key).split('/');
        if (splitUrl.length > 1) {
          invalidobject = invalidpath?.filter((item) => item.path === `/${splitUrl[1]}`)[0];
          validobject = updatepath?.filter((item) => item.path === initialinvalidpath + key)[0];
        } else {
          invalidobject = invalidpath?.filter((item) => item.path === initialinvalidpath + key)[0];
          validobject = updatepath?.filter((item) => item.path === initialinvalidpath + key)[0];
        }
      } catch (error) {
        invalidobject = invalidpath?.filter((item) => item.path === initialinvalidpath + key)[0];
        validobject = updatepath?.filter((item) => item.path === initialinvalidpath + key)[0];
      }

      if (invalidobject == undefined) {
        const parts = initialinvalidpath.split('/');
        const friendPath = parts[1];
        const id = parseInt(parts[2], 10);
        invalidobject = invalidpath?.filter((item, index) => {
          if (item.path === '/' + friendPath) {
            return index;
          }
        });
      }

      if (validobject == undefined) {
        const parts = initialinvalidpath.split('/');
        const friendPath = parts[1];
        const id = parseInt(parts[2], 10);
        validobject = updatepath?.filter((item, index) => {
          if (item.path === '/' + friendPath) {
            return index;
          }
        });
      }
      value = data[key];
    } else {
      // console.log('awdawdwad');
      // console.log(tittle);
      // tittle = '';
    }

    if (data[key] == '-234') {
      invalidobject = invalidpath?.filter((item) => item.path === initialinvalidpath + key)[0];
      validobject = updatepath?.filter((item) => item.path === initialinvalidpath + key)[0];
      value = null;
      tittle = '';
    }

    invalidpath?.filter((item) => {
      if (item.path === initialinvalidpath + key && determineType(item.new_value) == 'array' && type == 'add') {
        item.new_value = item.new_value.map((item2) => {
          if (determineType(item2) == 'unknown') {
            return '-234';
          }
        });
        value = item.new_value;
        return item;
      }
      return '';
    });

    updatepath?.filter((item) => {
      if (item.path === initialinvalidpath + key && determineType(item.new_value) == 'array' && type == 'add') {
        item.new_value = item.new_value.map((item2) => {
          if (determineType(item2) == 'unknown') {
            return '-234';
          }
        });
        value = item.new_value;
        return item;
      }
      return '';
    });

    // if (type == 'add') {
    //   value = dataTambahan.filter((item) => item.path === initialinvalidpath + key)[0]?.new_value;
    // }

    if (value == null) {
      if (
        key.includes('hash') ||
        key.includes('Hash') ||
        key.includes('HASH') ||
        key == 'bucketname' ||
        key == 'key' ||
        key == 'path' ||
        tittle == 'Bucket Name' ||
        tittle == 'Object Type' ||
        data[key] == 'ap-southeast-4' ||
        (tittle == 'Location' && data[key] == null)
      ) {
        return <span> </span>;
      }

      return (
        <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
          <Grid item>
            <Typography
              variant="body2"
              style={{
                color:
                  type == 'add'
                    ? ''
                    : checkPathContainsSubPath(
                        invalidpath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        updatepath,
                        updatepath
                      ) ||
                      invalidpath?.some((item) => item.path.includes(extractLastPathSegment(initialinvalidpath + key)))
                    ? 'red'
                    : updatepath?.some((item) =>
                        item.path.includes(extractLastPathSegment(initialinvalidpath + key))
                      ) ||
                      checkPathContainsSubPath(
                        updatepath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        invalidpath
                      )
                    ? 'green'
                    : '',
              }}
            >
              {tittle}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="body2"
              style={{
                color:
                  type == 'add'
                    ? ''
                    : (height == 1 && authorized) ||
                      (validobject != undefined && !_.isEmpty(validobject)) ||
                      checkPathContainsSubPath(
                        updatepath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        invalidpath
                      )
                    ? 'green'
                    : checkPathContainsSubPath(
                        invalidpath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        updatepath
                      ) ||
                      (height == 1 && unauthorized) ||
                      (invalidobject != undefined && !_.isEmpty(invalidobject))
                    ? 'red'
                    : '',
              }}
            >
              {type == 'add'
                ? ''
                : (height == 1 && authorized) ||
                  (validobject != undefined && !_.isEmpty(validobject)) ||
                  checkPathContainsSubPath(
                    updatepath,
                    extractLastPathSegment(initialinvalidpath + key),
                    initialinvalidpath + key,
                    invalidpath
                  )
                ? '(Authorized change detected)'
                : checkPathContainsSubPath(
                    invalidpath,
                    extractLastPathSegment(initialinvalidpath + key),
                    initialinvalidpath + key,
                    updatepath
                  ) ||
                  (height == 1 && unauthorized) ||
                  (invalidobject != undefined && !_.isEmpty(invalidobject))
                ? '(Unauthorized change detected)'
                : ''}
            </Typography>
          </Grid>
          <TextField
            variant="outlined"
            value={type != 'add' ? '' : value == null ? '' : value}
            fullWidth
            InputProps={{
              readOnly: true,
              disableUnderline: true,
              style: {
                borderRadius:
                  type == 'add'
                    ? ''
                    : checkPathContainsSubPath(
                        invalidpath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        updatepath
                      ) ||
                      (invalidobject != undefined && !_.isEmpty(invalidobject)) ||
                      height == 1 ||
                      (validobject != undefined && !_.isEmpty(validobject))
                    ? 'var(--main-system-4-px, 4px)'
                    : '',
                border:
                  type == 'add'
                    ? ''
                    : (height == 1 && authorized) ||
                      (validobject != undefined && !_.isEmpty(validobject)) ||
                      checkPathContainsSubPath(
                        updatepath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        invalidpath
                      )
                    ? '1px solid var(--red-500, #4c9a34)'
                    : checkPathContainsSubPath(
                        invalidpath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        updatepath
                      ) ||
                      (height == 1 && unauthorized) ||
                      (invalidobject != undefined && !_.isEmpty(invalidobject))
                    ? '1px solid var(--red-500, #FF293F)'
                    : '',

                backgroundColor:
                  type == 'add'
                    ? ''
                    : (height == 1 && authorized) ||
                      (validobject != undefined && !_.isEmpty(validobject)) ||
                      checkPathContainsSubPath(
                        updatepath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        invalidpath
                      )
                    ? 'var(--yellow-100, #dcffd7)'
                    : checkPathContainsSubPath(
                        invalidpath,
                        extractLastPathSegment(initialinvalidpath + key),
                        initialinvalidpath + key,
                        updatepath
                      ) ||
                      (height == 1 && unauthorized) ||
                      (invalidobject != undefined && !_.isEmpty(invalidobject))
                    ? ' var(--yellow-100, #FFF2C6)'
                    : '',
              },
            }}
          />
        </Grid>
      );
    }

    if (
      key.includes('hash') ||
      key.includes('Hash') ||
      key.includes('HASH') ||
      key == 'bucketname' ||
      key == 'key' ||
      key == 'path' ||
      tittle == 'Bucket Name' ||
      tittle == 'Object Type' ||
      data[key] == 'ap-southeast-4' ||
      tittle == 'Location'
    ) {
      return <span> </span>;
    }
    return typevalue == 'object' ? (
      <Grid item container direction={'row'} spacing={2}>
        {determineType(value) == 'array' ? (
          <Grid item container direction={'row'} spacing={2}>
            <Grid item alignSelf={'center'}>
              {' '}
              <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
            </Grid>
            <Grid item>
              <Typography variant="h5">{capitalizeFirstLetter(key)}</Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid item>
            <Typography variant="h5">{capitalizeFirstLetter(key.length == 1 ? '' : key)}</Typography>
          </Grid>
        )}
        {GenerateObject({
          type: type,
          data: value,
          invalidpath: invalidpath,
          initialinvalidpath: initialinvalidpath + key + '/',
          updatepath: updatepath,
          height: height,
          closedStatus: closedStatus,
          authorized: authorized,
          unauthorized: unauthorized,
        })}
      </Grid>
    ) : (
      <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
        <Grid item>
          <Typography
            variant="body2"
            style={{
              color:
                type == 'add'
                  ? ''
                  : (height == 1 && authorized) ||
                    (validobject != undefined && !_.isEmpty(validobject)) ||
                    checkPathContainsSubPath(
                      updatepath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      invalidpath
                    )
                  ? 'green'
                  : checkPathContainsSubPath(
                      invalidpath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      updatepath
                    ) ||
                    (height == 1 && unauthorized) ||
                    (invalidobject != undefined && !_.isEmpty(invalidobject))
                  ? 'red'
                  : '',
            }}
          >
            {value == null ? '--' : tittle}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="body2"
            style={{
              color:
                type == 'add'
                  ? ''
                  : (height == 1 && authorized) ||
                    (validobject != undefined && !_.isEmpty(validobject)) ||
                    checkPathContainsSubPath(
                      updatepath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      invalidpath
                    )
                  ? 'green'
                  : checkPathContainsSubPath(
                      invalidpath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      updatepath
                    ) ||
                    (height == 1 && unauthorized) ||
                    (invalidobject != undefined && !_.isEmpty(invalidobject))
                  ? 'red'
                  : '',
            }}
          >
            {type == 'add'
              ? ''
              : (height == 1 && authorized) ||
                (validobject != undefined && !_.isEmpty(validobject)) ||
                checkPathContainsSubPath(
                  updatepath,
                  extractLastPathSegment(initialinvalidpath + key),
                  initialinvalidpath + key,
                  invalidpath
                )
              ? '(Authorized change detected)'
              : checkPathContainsSubPath(
                  invalidpath,
                  extractLastPathSegment(initialinvalidpath + key),
                  initialinvalidpath + key,
                  updatepath
                ) ||
                (height == 1 && unauthorized) ||
                (invalidobject != undefined && !_.isEmpty(invalidobject))
              ? '(Unauthorized change detected)'
              : ''}
          </Typography>
        </Grid>
        <TextField
          variant="outlined"
          value={value}
          fullWidth
          InputProps={{
            readOnly: true,
            disableUnderline: true,
            style: {
              borderRadius:
                type == 'add'
                  ? ''
                  : height == 1 ||
                    (invalidobject != undefined && !_.isEmpty(invalidobject)) ||
                    (validobject != undefined && !_.isEmpty(validobject)) ||
                    checkPathContainsSubPath(
                      invalidpath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      updatepath
                    ) ||
                    checkPathContainsSubPath(
                      updatepath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      invalidpath
                    )
                  ? 'var(--main-system-4-px, 4px)'
                  : '',
              border:
                type == 'add'
                  ? ''
                  : (height == 1 && authorized) ||
                    (validobject != undefined && !_.isEmpty(validobject)) ||
                    checkPathContainsSubPath(
                      updatepath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      invalidpath
                    )
                  ? '1px solid var(--red-500, #4c9a34)'
                  : checkPathContainsSubPath(
                      invalidpath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      updatepath
                    ) ||
                    (height == 1 && unauthorized) ||
                    (invalidobject != undefined && !_.isEmpty(invalidobject))
                  ? '1px solid var(--red-500, #FF293F)'
                  : '',

              backgroundColor:
                type == 'add'
                  ? ''
                  : (height == 1 && authorized) ||
                    (validobject != undefined && !_.isEmpty(validobject)) ||
                    checkPathContainsSubPath(
                      updatepath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      invalidpath
                    )
                  ? 'var(--yellow-100, #dcffd7)'
                  : checkPathContainsSubPath(
                      invalidpath,
                      extractLastPathSegment(initialinvalidpath + key),
                      initialinvalidpath + key,
                      updatepath
                    ) ||
                    (height == 1 && unauthorized) ||
                    (invalidobject != undefined && !_.isEmpty(invalidobject))
                  ? ' var(--yellow-100, #FFF2C6)'
                  : '',
            },
          }}
        />
      </Grid>
    );
  });
}

const capitalizeFirstLetter = (str) => {
  return formatCamelCase(str.charAt(0).toUpperCase() + str.slice(1));
};
const checkValueType = (value) => {
  return typeof value;
};

function ComponentAuth({ color, title }) {
  return (
    <Grid item container xs={2.5} direction={'row'}>
      <Grid item container direction={'row'} spacing={2} style={{ paddingLeft: 30 }}>
        <Grid item alignSelf={'center'}>
          <CircleIcon style={{ color: color, fontSize: 15 }} />
        </Grid>
        <Grid item>
          <Typography variant="caption" style={{ color: '#888888' }}>
            {' '}
            {title}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

function CardHeader(data, datachenges, orderlist) {
  const { t } = useTranslation();

  return (
    <Card style={{ padding: 20 }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item alignSelf={'center'}>
            {' '}
            <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">{data.id}</Typography>
          </Grid>
        </Grid>
        {Detail({
          title: t('DateTime.1'),
          value: data.createdAt,
          title2: 'Dataset',
          value2: data?.dataSet ?? '',
        })}
        {Detail({
          title: 'Record ID',
          value: data?.recordId,
          title2: 'Folder',
          value2: data?.folder ?? '',
        })}
        {Detail({
          title: t('NumberOf.1'),
          value: data?.number || 0,
          title2: '',
          value2: '',
        })}
      </Grid>
    </Card>
  );
}
const isAnyNoteEmpty = (data, status) => {
  // if (status == 'pendingApproval') {
  //   return false;
  // }
  // Iterate through each data entry
  for (const entry of data) {
    // Iterate through the steps array of each entry
    for (const step of entry.steps) {
      // Check if the note is empty
      if (!step.note.trim()) {
        return true; // Return true if any note is empty
      }
    }
  }
  return false; // Return false if all notes are non-empty
};

function HisrotySection({ history = [] }) {
  return (
    <Card style={{ padding: 20 }}>
      {' '}
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item alignSelf={'center'}>
            {' '}
            <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">History</Typography>
          </Grid>
        </Grid>

        {history.map((item) => {
          const createdDate = new Date(item.created_at);
          const gmtPlus7Date = new Date(createdDate.getTime() + 7 * 60 * 60 * 1000); // Add 7 hours to the UTC date
          return (
            <Grid item xs={12} container direction={'row'} spacing={2} style={{ paddingLeft: 40 }}>
              <Grid item alignSelf={'center'}>
                <CircleIcon style={{ color: '#BFEAF8', fontSize: 10 }} />
              </Grid>
              <Grid item>
                <Avatar sizes="small" />
              </Grid>
              <Grid item container direction={'row'} xs={3}>
                <Grid item xs={12}>
                  <Typography variant="caption">{item.description}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption">{gmtPlus7Date.toLocaleString()}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={1} style={{ borderRight: '1px solid #e0e0e0', margin: 10 }}>
                {/* Empty content for the vertical line, adjust padding as needed */}
              </Grid>
              <Grid item>
                <Typography variant="subtittle2">
                  {item.status == 'inProgress'
                    ? item.Role + ' Change The Status Into In Progress'
                    : item.Role +
                      ' Change The Status Into ' +
                      (item.status == 'pendingRollback'
                        ? 'Pending Rollback'
                        : item.status == 'pendingApproval'
                        ? 'Pending Approval'
                        : item.status)}
                </Typography>
              </Grid>
            </Grid>
          );
        })}

        {/* {history.map((item) => {
          return (
            <Grid item xs={12} container direction={'row'}>
              {' '}
              <Grid item>
                <Typography style={{ marginLeft: 25 }}>{item.action_name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <hr style={{ marginTop: 20 }} />
              </Grid>
              {item.steps.map((item2, index) => {
                return (
                  <Grid item xs={12} container direction={'row'}>
                    <Grid item xs={12}>
                      <Typography>Step {index + 1}</Typography>
                    </Grid>
                    <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
                      <Grid item alignSelf={'center'}>
                        <Typography>{item2.description}</Typography>
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          multiline
                          disabled={status != 'open'}
                          fullWidth
                          variant="outlined"
                          onChange={(event) => {
                            setAction((prevState) => ({
                              ...prevState,
                              data: prevState.data.map((item3) => {
                                if (item3.id === item.id) {
                                  item3.steps.map((item4) => {
                                    if (item4.id === item2.id) {
                                      item4.note = event.target.value;
                                    }
                                  });
                                }
                                return item3;
                              }),
                            }));
                            // console.log(action.filter((item3) => item3.id === item.id)[0].steps);
                          }}
                          value={item2.note}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
              <Grid item xs={12}>
                <hr style={{ marginTop: 20 }} />
              </Grid>
              {status == 'closed' ? (
                ''
              ) : status == 'open' ? (
                <Grid
                  item
                  xs={12}
                  container
                  direction={'row'}
                  justifyContent={'center'}
                  spacing={2}
                  style={{ marginTop: 10 }}
                >
                  <Grid item>
                    <Button
                      disabled={isAnyNoteEmpty(action)}
                      variant="outlined"
                      onClick={() => {
                        // setNewstatus('inProgress');
                        fetchInfo6('inProgress');
                      }}
                      style={{ backgroundColor: 'white', color: isAnyNoteEmpty(action) ? '#86DCF3' : '#12A2CE' }}
                    >
                      Process
                    </Button>
                  </Grid>
                </Grid>
              ) : status == 'inProgress' ? (
                <Grid
                  item
                  xs={12}
                  container
                  direction={'row'}
                  justifyContent={'center'}
                  spacing={2}
                  style={{ marginTop: 10 }}
                >
                  <Grid item>
                    <Button
                      disabled={isAnyNoteEmpty(action)}
                      variant="outlined"
                      onClick={() => {
                        // setNewstatus('open');
                        fetchInfo6('oepn');
                      }}
                      style={{ backgroundColor: 'white', color: isAnyNoteEmpty(action) ? '#86DCF3' : '#12A2CE' }}
                    >
                      Reject
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={isAnyNoteEmpty(action)}
                      variant="outlined"
                      style={{ backgroundColor: isAnyNoteEmpty(action) ? '#86DCF3' : '#12A2CE', color: 'white' }}
                      onClick={() => {
                        // setNewstatus('closed');
                        fetchInfo6('closed');
                      }}
                    >
                      Approve
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  container
                  direction={'row'}
                  justifyContent={'center'}
                  spacing={2}
                  style={{ marginTop: 10 }}
                >
                  <Grid item>
                    <Button
                      disabled={isAnyNoteEmpty(action)}
                      variant="outlined"
                      onClick={() => {
                        setNewstatus('');
                      }}
                      style={{ backgroundColor: 'white', color: isAnyNoteEmpty(action) ? '#86DCF3' : '#12A2CE' }}
                    >
                      Keep
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={isAnyNoteEmpty(action)}
                      variant="outlined"
                      style={{ backgroundColor: isAnyNoteEmpty(action) ? '#86DCF3' : '#12A2CE', color: 'white' }}
                      onClick={() => {
                        console.log(action);
                      }}
                    >
                      Rollback
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          );
        })} */}
      </Grid>
    </Card>
  );
}

function ActionSection({
  action = [],
  setAction,
  status,
  fetchInfo6,
  fetchapprovechecker,
  setNewstatus,
  dialogUpload,
  files,
  setFiles,
  newstatusprocess,
  setNewstatusprocess,
  closedStatus,
  dataset,
  acl,
}) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 5,
    p: 4,
  };

  const [openeds, setOpeneds] = React.useState(false);
  const [openedsroll, setOpenedsroll] = React.useState(false);
  const [openedskeep, setOpenedskeep] = React.useState(false);
  const [Rejects, setRejects] = React.useState(false);
  const [openedsroll2, setOpenedsroll2] = React.useState(false);
  const [openedskeep2, setOpenedskeep2] = React.useState(false);
  const handleOpeneds = () => setOpeneds(true);
  const handleOpenedsroll = () => setOpenedsroll(true);
  const handleOpenedskeep = () => setOpenedskeep(true);
  const handleRejects = () => setRejects(true);
  const handleOpenedsroll2 = () => setOpenedsroll2(true);
  const handleOpenedskeep2 = () => setOpenedskeep2(true);
  const handleCloseds = () => setOpeneds(false);
  const handleClosedsroll = () => setOpenedsroll(false);
  const handleClosedskeep = () => setOpenedskeep(false);
  const handleClosedsRejects = () => setRejects(false);
  const handleClosedsroll2 = () => setOpenedsroll2(false);
  const handleClosedskeep2 = () => setOpenedskeep2(false);
  const cancelButtonRef = useRef(null);

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  const handleDownload = async (id, fileName) => {
    try {
      // Make a request to your backend to download the file
      const response = await fetch(window.REACT_APP_API_PURE + `file/download?id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Check if the response is okay
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }

      // Get the blob from the response
      const blob = await response.blob();

      // Create a link element to download the file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      // Append the link to the body and click it to start the download
      document.body.appendChild(link);
      link.click();

      // Clean up by removing the link and revoking the object URL
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const handleClickProceed = () => {
    setIsLoading(true);
    if (isAnyNoteEmpty(action, status)) {
      if (status == 'inProgress') {
        fetchInfo6(newstatusprocess.status, newstatusprocess.closed_status);
      } else {
        fetchInfo6('inProgress', '');
      }
    } else if (status == 'open') {
      fetchInfo6(newstatusprocess.status, newstatusprocess.closed_status);
    } else {
      fetchInfo6(newstatusprocess.status, newstatusprocess.closed_status);
    }
    // Simulate an async operation like an API call
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  const handleClickApprove = () => {
    setIsLoading(true);
    fetchapprovechecker(newstatusprocess.status, newstatusprocess.closed_status);
    // Simulate an async operation like an API call
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const handleClickReject = () => {
    setIsLoading(true);
    fetchapprovechecker(newstatusprocess.status, newstatusprocess.closed_status);
    // Simulate an async operation like an API call
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const translatedData = closedStatus ? t(`closedtatus1.${closedStatus}`) : null;
  return (
    <Card style={{ padding: 20 }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={12} container direction={'row'} spacing={2}>
          <Grid item alignSelf={'center'}>
            {' '}
            <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
          </Grid>
          <Modal
            open={openeds}
            onClose={handleCloseds}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-7 w-7 text-yellow-500" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Typography as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      {t('ProceedButton.1')}
                    </Typography>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{t('ProcessPrompt.1')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  disabled={isLoading}
                  style={{ backgroundColor: isLoading ? 'gray' : 'var(--yellow-400, #FFD700)', color: 'white' }}
                  className="inline-flex w-full justify-center rounded-md bg-yellow-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleClickProceed();
                  }}
                >
                  {isLoading ? 'Loading...' : t('ProceedButton.1')}
                </button>
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setOpeneds(false)}
                  ref={cancelButtonRef}
                >
                  {t('CancelButton.1')}
                </button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openedsroll}
            onClose={handleClosedsroll}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-7 w-7 text-yellow-500" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Typography as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      {t('PromptApproval.1', { data: translatedData })}
                    </Typography>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {t('PromptApproval.2')} {t(`closedtatus2.${closedStatus}`)}
                        {t('PromptApproval.3')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  disabled={isLoading}
                  style={{ backgroundColor: isLoading ? 'gray' : 'var(--yellow-400, #FFD700)', color: 'white' }}
                  className="inline-flex w-full justify-center rounded-md bg-yellow-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleClickApprove();
                  }}
                >
                  {isLoading ? 'Loading...' : t(`closedtatus1.${closedStatus}`)}
                </button>
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setOpenedsroll(false)}
                  ref={cancelButtonRef}
                >
                  {t('Cancel.1')}
                </button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={Rejects}
            onClose={handleClosedsRejects}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-7 w-7 text-yellow-500" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Typography as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      {t('PromptReject.1')}
                    </Typography>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{t('PromptReject.2')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  disabled={isLoading}
                  style={{ backgroundColor: isLoading ? 'gray' : 'var(--yellow-400, #FFD700)', color: 'white' }}
                  className="inline-flex w-full justify-center rounded-md bg-yellow-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleClickReject();
                  }}
                >
                  {isLoading ? 'Loading...' : t('Reject.1')}
                </button>
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setRejects(false)}
                  ref={cancelButtonRef}
                >
                  {t('Cancel.1')}
                </button>
              </div>
            </Box>
          </Modal>
          <Grid item>
            <Typography variant="h5">Action</Typography>
          </Grid>
        </Grid>

        {action == null && acl?.create ? (
          <Grid item xs={12} container direction={'row'} justifyContent={'center'}>
            <Link to={'/dashboard/action/add?dataset=' + dataset}>
              <Button variant="outlined" style={{ color: '#30a2ce' }}>
                {t('AssignAction.1')}
              </Button>
            </Link>
          </Grid>
        ) : (
          action?.map((item, index) => {
            return (
              <Grid item xs={12} container direction={'row'}>
                {' '}
                <Grid item>
                  <Typography style={{ marginLeft: 25 }}>{item.action_name}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <hr style={{ marginTop: 20 }} />
                </Grid>
                {item.steps.map((item2, index) => {
                  return (
                    <Grid item xs={12} container direction={'row'}>
                      <Grid item style={{ marginBottom: 30 }} xs={12}>
                        {' '}
                      </Grid>
                      <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
                        <Grid item alignSelf={'center'} xs={6}>
                          <Typography>{item2.description}</Typography>
                        </Grid>
                        <Grid item md={6}>
                          <TextField
                            multiline
                            disabled={status == 'pendingApproval' || status == 'pendingRollback' || status == 'closed'}
                            fullWidth
                            variant="outlined"
                            onChange={(event) => {
                              setAction((prevState) => ({
                                ...prevState,
                                data: prevState.data.map((item3) => {
                                  if (item3.id === item.id) {
                                    item3.steps.map((item4) => {
                                      if (item4.id === item2.id) {
                                        item4.note = event.target.value;
                                      }
                                    });
                                  }
                                  return item3;
                                }),
                              }));
                              // console.log(action.filter((item3) => item3.id === item.id)[0].steps);
                            }}
                            value={item2.note}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
                <Grid item xs={12}>
                  <hr style={{ marginTop: 20 }} />
                </Grid>
                {status == 'closed' || privilage(status) ? (
                  index + 1 != action.length ? (
                    ''
                  ) : (
                    <Grid item xs={12} container direction={'row'} spacing={2}>
                      {files.map((item, index) => (
                        <Grid item xs={4}>
                          <Card
                            variant="outlined"
                            style={{
                              marginBottom: 0,
                              maxHeight: '100px',
                              backgroundColor: '#EEF1F7',
                              position: 'relative',
                            }}
                          >
                            <CardContent>
                              <Grid container direction={'row'} spacing={2}>
                                <Grid item style={{ alignSelf: 'center' }}>
                                  <CloudCircleIcon fontSize="large" />
                                </Grid>
                                <Grid xs item container direction={'row'}>
                                  <Grid item xs={12}>
                                    <Typography variant="body1"> {item.nama_file}</Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography variant="caption">
                                      {new Date(item.created_at * 1000).toLocaleDateString()}
                                    </Typography>
                                  </Grid>
                                  {/* <Grid item style={{ paddingLeft: 20 }}>
                                    <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />
                                  </Grid>
                                  <Grid item>
                                    <Typography variant="caption">Complete</Typography>
                                  </Grid> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <IconButton
                                    style={{ position: 'absolute', top: 0, right: 30 }}
                                    onClick={() => {
                                      handleDownload(item.id, item.nama_file);
                                    }}
                                  >
                                    <ArrowCircleDownOutlined style={{ color: 'green' }} />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  )
                ) : status == 'open' ? (
                  <Grid
                    item
                    xs={12}
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={2}
                    style={{ marginTop: 10 }}
                  >
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} container direction={'row'} spacing={2}>
                        {files.map((item, index) => (
                          <Grid item xs={4}>
                            <Card
                              variant="outlined"
                              style={{
                                marginBottom: 0,
                                maxHeight: '100px',
                                backgroundColor: '#EEF1F7',
                                position: 'relative',
                              }}
                            >
                              <CardContent>
                                <Grid container direction={'row'} spacing={2}>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                    <CloudCircleIcon fontSize="large" />
                                  </Grid>
                                  <Grid xs item container direction={'row'}>
                                    <Grid item xs={12}>
                                      <Typography variant="body1"> {item.name}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="caption">{(item.size / 1048576).toFixed(2)} MB</Typography>
                                    </Grid>
                                    <Grid item style={{ paddingLeft: 20 }}>
                                      <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="caption">Complete</Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </CardContent>
                              <IconButton
                                style={{ position: 'absolute', top: 0, right: 0 }}
                                onClick={() => {
                                  // Remove the files array item by index
                                  const updatedFiles = [...files];
                                  updatedFiles.splice(index, 1);
                                  setFiles(updatedFiles);
                                }}
                              >
                                <CloseIcon style={{ color: 'red' }} />
                              </IconButton>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} style={{ textAlignLast: 'center' }}>
                        <Button
                          onClick={() => {
                            dialogUpload.handleClose();
                          }}
                        >
                          {' '}
                          {t('UploadButton.1')}
                        </Button>
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : isAnyNoteEmpty(action, status) ? (
                      <Grid item container direction={'row'} spacing={2} xs={12} justifyContent={'center'}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'open',
                                closed_status: '',
                              });
                              handleOpeneds();
                            }}
                          >
                            {t('SaveButton.2')}
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid item container direction={'row'} spacing={2} xs={12} justifyContent={'center'}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'pendingApproval',
                                closed_status: 'rollback',
                              });
                              handleOpeneds();
                            }}
                            disabled={isAnyNoteEmpty(action, status)}
                          >
                            {t('RecommendationButton.1')}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'pendingApproval',
                                closed_status: 'keep',
                              });
                              handleOpeneds();
                            }}
                            disabled={isAnyNoteEmpty(action, status)}
                          >
                            {t('RecommendationButton.2')}
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                ) : status == 'inProgress' ? (
                  <Grid
                    item
                    xs={12}
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={2}
                    style={{ marginTop: 10 }}
                  >
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} container direction={'row'} spacing={2}>
                        {files.map((item, index) => (
                          <Grid item xs={4}>
                            <Card
                              variant="outlined"
                              style={{
                                marginBottom: 0,
                                maxHeight: '100px',
                                backgroundColor: '#EEF1F7',
                                position: 'relative',
                              }}
                            >
                              <CardContent>
                                <Grid container direction={'row'} spacing={2}>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                    <CloudCircleIcon fontSize="large" />
                                  </Grid>
                                  <Grid xs item container direction={'row'}>
                                    <Grid item xs={6}>
                                      <Typography variant="body1"> {item.nama_file || item.name}</Typography>
                                    </Grid>
                                    <Grid item>
                                      {/* <Typography variant="caption">
                                        {new Date(item.created_at * 1000).toLocaleDateString()}
                                      </Typography> */}
                                    </Grid>
                                    <Grid item xs={6}>
                                      <IconButton
                                        style={{ position: 'absolute', top: 0, right: 30 }}
                                        onClick={() => {
                                          handleDownload(item.id, item.nama_file);
                                        }}
                                      >
                                        <ArrowCircleDownOutlined style={{ color: 'green' }} />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </CardContent>
                              <IconButton
                                style={{ position: 'absolute', top: 0, right: 0 }}
                                onClick={() => {
                                  // Remove the files array item by index
                                  const updatedFiles = [...files];
                                  updatedFiles.splice(index, 1);
                                  setFiles(updatedFiles);
                                }}
                              >
                                <CloseIcon style={{ color: 'red' }} />
                              </IconButton>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} style={{ textAlignLast: 'center' }}>
                        <Button
                          onClick={() => {
                            dialogUpload.handleClose();
                          }}
                        >
                          {' '}
                          {t('UploadButton.1')}
                        </Button>
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : isAnyNoteEmpty(action, status) ? (
                      <Grid item container direction={'row'} spacing={2} xs={12} justifyContent={'center'}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'inProgress',
                                closed_status: '',
                              });
                              handleOpeneds();
                            }}
                          >
                            {t('SaveButton.1')}
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid item container direction={'row'} spacing={2} xs={12} justifyContent={'center'}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'pendingApproval',
                                closed_status: 'rollback',
                              });
                              handleOpeneds();
                            }}
                            disabled={isAnyNoteEmpty(action, status)}
                          >
                            {t('RecommendationButton.1')}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setNewstatusprocess({
                                status: 'pendingApproval',
                                closed_status: 'keep',
                              });
                              handleOpeneds();
                            }}
                            disabled={isAnyNoteEmpty(action, status)}
                          >
                            {t('RecommendationButton.2')}
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                ) : status == 'pendingApproval' ? (
                  <Grid
                    item
                    xs={12}
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={2}
                    style={{ marginTop: 0 }}
                  >
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} container direction={'row'} spacing={2}>
                        {files.map((item, index) => (
                          <Grid item xs={4}>
                            <Card
                              variant="outlined"
                              style={{
                                marginBottom: 0,
                                maxHeight: '100px',
                                backgroundColor: '#EEF1F7',
                                position: 'relative',
                              }}
                            >
                              <CardContent>
                                <Grid container direction={'row'} spacing={2}>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                    <CloudCircleIcon fontSize="large" />
                                  </Grid>
                                  <Grid xs item container direction={'row'}>
                                    <Grid item xs={12}>
                                      <Typography variant="body1"> {item.nama_file}</Typography>
                                    </Grid>{' '}
                                    <Grid item>
                                      <Typography variant="caption">
                                        {new Date(item.created_at * 1000).toLocaleDateString()}
                                      </Typography>
                                    </Grid>
                                    <Grid item style={{ paddingLeft: 20 }}>
                                      <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="caption">Complete</Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <IconButton
                                      style={{ position: 'absolute', top: 0, right: 30 }}
                                      onClick={() => {
                                        handleDownload(item.id, item.nama_file);
                                      }}
                                    >
                                      <ArrowCircleDownOutlined style={{ color: 'green' }} />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item>
                        <Button
                          disabled={isAnyNoteEmpty(action, status)}
                          variant="outlined"
                          onClick={() => {
                            setNewstatusprocess({
                              status: 'inProgress',
                              closed_status: 'Reject',
                            });

                            handleRejects();
                          }}
                          style={{
                            backgroundColor: 'white',
                            color: isAnyNoteEmpty(action, status) ? '#86DCF3' : '#12A2CE',
                          }}
                        >
                          {t('Reject.1')}
                        </Button>
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item>
                        <Button
                          disabled={isAnyNoteEmpty(action, status)}
                          variant="outlined"
                          style={{
                            backgroundColor: isAnyNoteEmpty(action, status) ? '#86DCF3' : '#12A2CE',
                            color: 'white',
                          }}
                          onClick={() => {
                            if (closedStatus == 'keep') {
                              setNewstatusprocess({
                                status: 'closed',
                                closed_status: 'keep',
                              });
                            } else if (closedStatus == 'rollback') {
                              setNewstatusprocess({
                                status: 'pendingRollback',
                                closed_status: 'rollback',
                              });
                            }

                            handleOpenedsroll();
                          }}
                        >
                          {t('ApproveButton.1')} {t(`closedtatus.${closedStatus}`)}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                ) : status == 'pendingRollback' ? (
                  <Grid
                    item
                    xs={12}
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={2}
                    style={{ marginTop: 10 }}
                  >
                    {' '}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} container direction={'row'} spacing={2}>
                        {files.map((item, index) => (
                          <Grid item xs={4}>
                            <Card
                              variant="outlined"
                              style={{
                                marginBottom: 0,
                                maxHeight: '100px',
                                backgroundColor: '#EEF1F7',
                                position: 'relative',
                              }}
                            >
                              <CardContent>
                                <Grid container direction={'row'} spacing={2}>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                    <CloudCircleIcon fontSize="large" />
                                  </Grid>
                                  <Grid xs item container direction={'row'}>
                                    <Grid item xs={12}>
                                      <Typography variant="body1"> {item.nama_file}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="caption">
                                        {new Date(item.created_at * 1000).toLocaleDateString()}
                                      </Typography>
                                    </Grid>
                                    <Grid item style={{ paddingLeft: 20 }}>
                                      <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="caption">Complete</Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <IconButton
                                      style={{ position: 'absolute', top: 0, right: 30 }}
                                      onClick={() => {
                                        handleDownload(item.id, item.nama_file);
                                      }}
                                    >
                                      <ArrowCircleDownOutlined style={{ color: 'green' }} />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <span></span>
                      // <Grid item>
                      //   <Button
                      //     // disabled={isAnyNoteEmpty(action, status)}
                      //     variant="outlined"
                      //     style={{
                      //       backgroundColor: '#12A2CE',
                      //       color: 'white',
                      //     }}
                      //     // onClick={() => {
                      //     //   fetchInfo6('closed', 'rollback');
                      //     // }}
                      //     onClick={handleOpenedsroll2}
                      //   >
                      //     Rollback
                      //   </Button>
                      // </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={2}
                    style={{ marginTop: 10 }}
                  >
                    {index + 1 != action.length ? (
                      ''
                    ) : (
                      <Grid item xs={12} container direction={'row'} spacing={2}>
                        {files.map((item, index) => (
                          <Grid item xs={4}>
                            <Card
                              variant="outlined"
                              style={{
                                marginBottom: 0,
                                maxHeight: '100px',
                                backgroundColor: '#EEF1F7',
                                position: 'relative',
                              }}
                            >
                              <CardContent>
                                <Grid container direction={'row'} spacing={2}>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                    <CloudCircleIcon fontSize="large" />
                                  </Grid>
                                  <Grid xs item container direction={'row'}>
                                    <Grid item xs={12}>
                                      <Typography variant="body1"> {item.nama_file}</Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <IconButton
                                      style={{ position: 'absolute', top: 0, right: 30 }}
                                      onClick={() => {
                                        handleDownload(item.id, item.nama_file);
                                      }}
                                    >
                                      <ArrowCircleDownOutlined style={{ color: 'green' }} />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    <Grid item>
                      <Button
                        disabled={isAnyNoteEmpty(action, status)}
                        variant="outlined"
                        onClick={handleOpenedskeep2}
                        style={{
                          backgroundColor: 'white',
                          color: isAnyNoteEmpty(action, status) ? '#86DCF3' : '#12A2CE',
                        }}
                      >
                        {t('KeepButton.1')}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        disabled={isAnyNoteEmpty(action, status)}
                        variant="outlined"
                        style={{
                          backgroundColor: isAnyNoteEmpty(action, status) ? '#86DCF3' : '#12A2CE',
                          color: 'white',
                        }}
                        onClick={() => {
                          console.log(action);
                        }}
                      >
                        Rollback
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            );
          })
        )}
      </Grid>
    </Card>
  );
}

function CardBack(navigate) {
  return (
    <Card style={{ padding: 20 }}>
      <Grid container direction={'row'}>
        <Grid item>
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
            style={{ color: '#1EB3D9' }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Grid>
        <Grid item alignSelf={'center'}>
          <Typography variant="h5"> Details</Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

function Detail({ title, value, title2, value2 }) {
  return (
    <Grid item xs={12} container direction={'row'} style={{ marginLeft: 30 }}>
      <Grid item xs={2}>
        <Typography variant="body2">{title}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2">: {value}</Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2">{title2}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2"> {value2 == '' ? '' : ': ' + value2}</Typography>
      </Grid>
    </Grid>
  );
}
const formatCamelCase = (str) => {
  // Use a regular expression to split camelCase into words
  const words = str.split(/(?=[A-Z])/);

  // Join the words with a space
  const formattedString = words.join(' ');

  return formattedString;
};

function MyComponent({ valid = false, invalid = false, timeEpoch, isEndList = false }) {
  const date = new Date(timeEpoch);
  const options = { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Jakarta' };
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  const hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
  return (
    <>
      <div className="div">
        <div className="div-2">
          <div className={'div-3'}>
            <div className={'div-4'}>
              {valid && invalid ? (
                <span>
                  <img loading="lazy" src={'/assets/X.png'} alt="line Logo" className="img" />

                  <img loading="lazy" src={'/assets/close.png'} alt="line Logo" className="img" />
                </span>
              ) : (
                <img
                  loading="lazy"
                  src={valid ? '/assets/X.png' : '/assets/close.png'}
                  alt="line Logo"
                  className="img"
                />
              )}
            </div>
            {isEndList ? '' : <div className="div-5" />}
          </div>
          <div className="div-6">
            <img src="/assets/Line.png" alt="line Logo" className="w-100" />
            <div className="div-7">
              <div className="div-8">{formattedDate}</div>
              <div className="div-9">{formattedTime}</div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .div {
          display: flex;
          gap: 4px;
        }
        .div-2 {
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-3 {
          display: flex;
          justify-content: space-between;
          gap: 4px;
        }
        .div-4 {
          justify-content: center;
          align-items: center;
          border-radius: 131.413px;
          border: 1.027px solid var(--Stroke-Light-Base, #e5e5e7);
          box-shadow: 0px 1.027px 2.053px 0px rgba(16, 24, 40, 0.04);
          background-color: var(--Background-Light-Base-Main, #fff);
          display: flex;
          aspect-ratio: 1;
          flex-direction: column;
          width: 44px;
          height: 44px;
          padding: 0 12px;
        }
        .img {
          aspect-ratio: 0.95;
          object-fit: contain;
          object-position: center;
          width: 100%;
          overflow: hidden;
        }
        .div-5 {
          background-color: #bfeaf8;
          align-self: center;
          width: 55px;
          height: 1px;
          margin: auto 0;
        }
        .div-6 {
          align-items: start;
          display: flex;
          margin-top: 4px;
          justify-content: space-between;
          gap: 8px;
          padding: 0 19px;
        }
        .img-2 {
          aspect-ratio: 0.07;
          object-fit: contain;
          object-position: center;
          width: 1px;
          stroke-width: 1px;
          stroke: var(--Blue-300, #86dcf3);
          overflow: hidden;
          max-width: 100%;
        }
        .div-7 {
          align-self: stretch;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-8 {
          color: var(--Blue-700, #0e7496);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-9 {
          color: var(--Blue-700, #0e7496);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-10 {
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-11 {
          display: flex;
          justify-content: space-between;
          gap: 4px;
        }
        .div-12 {
          justify-content: center;
          align-items: center;
          border-radius: 131.413px;
          border: 1.027px solid var(--Stroke-Light-Base, #e5e5e7);
          box-shadow: 0px 1.027px 2.053px 0px rgba(16, 24, 40, 0.04);
          background-color: var(--Background-Light-Base-Main, #fff);
          display: flex;
          aspect-ratio: 1;
          flex-direction: column;
          width: 44px;
          height: 44px;
          padding: 0 12px;
        }
        .div-13 {
          background-color: #bfeaf8;
          align-self: center;
          width: 55px;
          height: 1px;
          margin: auto 0;
        }
        .div-14 {
          align-items: start;
          display: flex;
          margin-top: 4px;
          justify-content: space-between;
          gap: 8px;
          padding: 0 19px;
        }
        .img-3 {
          aspect-ratio: 0.07;
          object-fit: contain;
          object-position: center;
          width: 1px;
          stroke-width: 1px;
          stroke: var(--Red-400, #ff5b6c);
          overflow: hidden;
          max-width: 100%;
        }
        .div-15 {
          align-self: stretch;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-16 {
          color: var(--Red-600, #f90921);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-17 {
          color: var(--Red-600, #f90921);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
      `}</style>
    </>
  );
}

const privilage = (status) => {
  const role = getRole();

  if (role == 'super_admin') {
    return true;
  }

  if ((status == 'inProgress' || status == 'open') && role == 'maker') {
    return false;
  } else if (status == 'pendingApproval' && role == 'checker') {
    return false;
  }

  return true;
};

function transformChangesRemove(changes, before) {
  changes.forEach((change) => {
    const { path, operation, oldValue, newValue } = change;

    if (operation === 'remove' && (Array.isArray(oldValue) || typeof oldValue === 'object')) {
      const pathParts = path.split('/');
      let current = before;

      for (let i = 1; i < pathParts.length; i++) {
        const key = pathParts[i];
        if (i === pathParts.length - 1) {
          if (oldValue === null) {
            current[key] = null;
          } else if (Array.isArray(oldValue)) {
            current[key] = oldValue.map((obj) => Object.fromEntries(Object.keys(obj).map((k) => [k, null])));
          } else if (typeof oldValue === 'object') {
            current[key] = makeObjectValuesEmpty(oldValue);
          } else {
            current[key] = Object.fromEntries(Object.keys(oldValue).map((k) => [k, null]));
          }
        } else {
          if (typeof current[key] !== 'object' || current[key] === null) {
            current[key] = {};
          }
          current = current[key];
        }
      }
    }
  });

  return before;
}
function makeObjectValuesEmpty(obj) {
  const result = {};
  for (let key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      result[key] = makeObjectValuesEmpty(obj[key]);
    } else {
      result[key] = '';
    }
  }

  return result;
}

function checkPathContainsSubPath(data, subPath, fullPath, secoundData) {
  const splitUrl = fullPath?.split('/') || [];
  // if (splitUrl.length > 1) {
  //   invalidobject = invalidpath?.filter((item) => item.path === `/${splitUrl[1]}`)[0];

  if (!data || !Array.isArray(data)) {
    return false;
  }

  function checkValueContainsSubPath(value, subPath) {
    if (typeof value === 'object' && value !== null) {
      for (const key in value) {
        if (value.hasOwnProperty(key)) {
          if (key === subPath) {
            return true;
          }
          if (typeof value[key] === 'object') {
            if (checkValueContainsSubPath(value[key], subPath)) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  for (const item of data) {
    let valueToCheck = item.oldValue;
    let pathToCheck = item.path;
    if (valueToCheck === null) {
      valueToCheck = item.newValue;
    }

    for (let i = 1; i < splitUrl.length; i++) {
      const key = splitUrl[i];
      if (pathToCheck === `/${key}`) {
        if (secoundData != undefined || secoundData != null) {
          for (const item2 of secoundData) {
            let valueToCheck2 = item2.oldValue;
            let pathToCheck2 = item2.path;
            if (valueToCheck2 === null) {
              valueToCheck2 = item2.newValue;
            }
            if (fullPath == pathToCheck2) {
              return false;
            }
          }
        }
        return true;
      }
    }
    if (fullPath == pathToCheck) {
      return true;
    }

    // if (pathToCheck === `/${splitUrl[1]}`) {
    //   return true;
    // }

    // if (valueToCheck && typeof valueToCheck === 'object') {
    //   if (checkValueContainsSubPath(valueToCheck, subPath)) {
    //     return true;
    //   }
    // } else if (typeof valueToCheck === 'string' && valueToCheck.includes(subPath)) {
    //   return true;
    // }
  }
  return false;
}

function extractLastPathSegment(path) {
  if (path == undefined || path == null) return '';
  const segments = path.split('/');
  return segments[segments.length - 1];
}
